"use client";

import { setCurr } from "@/store";
import { memo, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { Hamburger } from "./Navbar/Hamburger";
import { HeaderBtnGroup } from "./Navbar/HeaderBtnGroup";
import { Logo } from "./Navbar/Logo";
import { MobileMenu } from "./Navbar/MobileMenu";
import { Navigation } from "./Navbar/Navigation";

export const Header = memo(function Header({ lang, siteName, currency, phone }) {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(setCurr(currency));
  }, []);

  return (
    <header className="bg-white font-manrope sticky top-0 z-999">
      <nav
        className="sm:mx-auto relative flex max-w-[1920px] items-center justify-between p-6 lg:px-7"
        aria-label="Global"
      >
        <Logo nameSite={siteName} />
        <div className="hidden lg:flex lg:gap-x-6 2xl:gap-x-15 items-center">
          <Navigation lang={lang} type="desktop" />
        </div>
        {/* <div className="hidden xl:flex items-center lg:gap-x-6"> */}
        <div className="flex items-center gap-x-2.5">
          <div className="flex gap-[1rem]">{<HeaderBtnGroup phone={phone} lang={lang} currency={currency} />}</div>
          <MobileMenu />
        </div>
        {/* </div> */}
      </nav>
      <Hamburger lang={lang} currency={currency} nameSite={siteName} />
    </header>
  );
});
